/* scroll-restore.js
 * Restores scroll position on back navigation (notably iOS swipe-back).
 * Scope: site-wide, but only activates when a saved scroll value exists for the exact URL.
 */
(function () {
  'use strict';

  // Guard against environments without sessionStorage (rare, but safe)
  var storage;
  try {
    storage = window.sessionStorage;
  } catch (e) {
    storage = null;
  }
  if (!storage) return;

  var KEY_PREFIX = 'sr:scroll:';
  var RESTORE_FLAG_PREFIX = 'sr:restore_pending:';

  function pageKey() {
    // Key by path + query so collection filters/sort/search are unique
    return KEY_PREFIX + window.location.pathname + window.location.search;
  }

  function restoreFlagKey() {
    return RESTORE_FLAG_PREFIX + window.location.pathname + window.location.search;
  }

  function saveScroll() {
    // Avoid saving during programmatic restore loops
    var y = window.scrollY || window.pageYOffset || 0;
    try {
      storage.setItem(pageKey(), String(y));
      // Mark that a restore is relevant if user comes back to this URL in this session
      storage.setItem(restoreFlagKey(), '1');
    } catch (e) {
      // ignore storage quota / blocked errors
    }
  }

  function clearRestoreFlag() {
    try {
      storage.removeItem(restoreFlagKey());
    } catch (e) {}
  }

  function getSavedScroll() {
    try {
      var val = storage.getItem(pageKey());
      if (val == null) return null;
      var n = parseInt(val, 10);
      return Number.isFinite(n) ? n : null;
    } catch (e) {
      return null;
    }
  }

  // Debounced scroll saving (lightweight)
  var scrollTimer = null;
  function onScroll() {
    if (scrollTimer) window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(function () {
      saveScroll();
      scrollTimer = null;
    }, 150);
  }

  // Extra save on link clicks (covers cases where pagehide is inconsistent)
  function onLinkClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;

    // Ignore anchors that don't navigate away
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;

    saveScroll();
  }

  // Best event for iOS navigation away (including swipe back)
  window.addEventListener('pagehide', saveScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('click', onLinkClick, { passive: true, capture: true });
  document.addEventListener('touchstart', onLinkClick, { passive: true, capture: true });

  // Restore on return
  window.addEventListener('pageshow', function () {
    // Only restore if we previously marked this URL as having a scroll state
    var shouldRestore = false;
    try {
      shouldRestore = storage.getItem(restoreFlagKey()) === '1';
    } catch (e) {
      shouldRestore = false;
    }
    if (!shouldRestore) return;

    var y = getSavedScroll();
    if (y == null) {
      clearRestoreFlag();
      return;
    }

    // Use two ticks to allow layout/content to settle (especially on collection grids)
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        window.scrollTo(0, y);
        // Clear the flag so it doesn't re-apply unexpectedly
        clearRestoreFlag();
      });
    });
  });
})();
